<template>
  <b-form-group
    label="Token"
    label-for="token"
  >
    <b-form-input
      id="token"
      v-model="dataItem.token"
      placeholder="Token"
      readonly
    />
  </b-form-group>
</template>

<script>
import { localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'LicenceToken',
  components: {
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['licenses/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
